import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asus_proart_sw_ico_arrow_fill_expand",
  "use": "asus_proart_sw_ico_arrow_fill_expand-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"asus_proart_sw_ico_arrow_fill_expand\"><g id=\"asus_proart_sw_ico_arrow_fill_expand_a\"></g><g id=\"asus_proart_sw_ico_arrow_fill_expand_b\"><g id=\"asus_proart_sw_ico_arrow_fill_expand_c\"><g id=\"asus_proart_sw_ico_arrow_fill_expand_d\"><rect width=\"48\" height=\"48\" transform=\"translate(48) rotate(90)\" fill=\"none\" /><polygon points=\"40 15 24 35 8 15 40 15\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol